/**
 * As abas do Mapa Macro e a ordem em que a barra as mostra.
 *
 * Moram fora da tela para a ORDEM e a aba padrão serem uma coisa só: a aba que abre sem
 * `?activeTab=` é sempre a primeira da barra, e não um segundo valor que alguém pode
 * esquecer de mexer junto.
 */

export const MAPA_TAB_SEMANA = 'semana';
export const MAPA_TAB_TIMELINE = 'timeline';

/** A aba que o Mapa abre sem `?activeTab=` na URL: a primeira da barra. */
export const MAPA_TAB_PADRAO = MAPA_TAB_SEMANA;
